import React from "react";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";

interface ToggleButtonProps {
  isOpen: boolean;
  onClick?: () => void;
  className?: string;
  title?: string;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  isOpen,
  onClick,
  className = "",
  title = "Toggle",
}) => {
  const buttonStyle = {
    borderRadius: "6px",
    padding: "6px 10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f5f5",
    borderColor: "#d1d5db",
    color: "#6b7280",
    transition: "all 0.2s ease",
    textDecoration: "none",
    width: "32px",
    height: "32px",
    cursor: "pointer",
    border: "1px solid #d1d5db",
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = "#e5e7eb";
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = "#f5f5f5";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  };

  return (
    <span
      onClick={onClick}
      className={`btn btn-sm ${className}`}
      style={buttonStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title={title}
    >
      {isOpen ? <AiOutlineUp size={16} /> : <AiOutlineDown size={16} />}
    </span>
  );
};

export default ToggleButton;
